import {
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    Observable,
    Subject,
    Subscription,
    finalize,
    map,
    startWith,
    takeUntil,
    tap,
} from 'rxjs';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { helper } from 'src/environments/helper';
import { CereriService } from '../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

import { DocumentGenerabilComponent } from './document-generabil/document-generabil.component';
import { DocumentAssignmentComponent } from './document-assignment/document-assignment.component';
import { MatDialog } from '@angular/material/dialog';

import {
    ICerere,
    DocumentCetatean,
    RequestMessageInternPayload,
    RequestMessageNotitaPayload,
    RequestMessageToCetateanPayload,
    DocumentGenerabil,
    Coleg,
    FileData,
} from '../cereri.interface';
import { AssignmentSummary } from './cerere-functii-assignment/cerere-functii-assignment.interface';
import { CerereFunctiiAssignmentComponent } from './cerere-functii-assignment/cerere-functii-assignment.component';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';

import { AppFilesService } from 'src/app/services/app-files.service';
import { COMMA, ENTER, L, P } from '@angular/cdk/keycodes';
import { CommonService } from 'src/app/services/common.service';
import { CerereValidareComponent } from './cerere-validare/cerere-validare.component';
import { EditDocumentOficialComponent } from './document-generabil/edit-document-oficial/edit-document-oficial.component';
import { IstoricDocumentGenerabilComponent } from './document-generabil/istoric-document-generabil/istoric-document-generabil.component';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { UsersService } from 'src/app/services/users.service';
import { ModalInchidereLucrareComponent } from './modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { DialogService } from 'src/app/services/dialog.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { CerereDetaliiSabloaneComponent } from './sabloane/cerere-detalii-sabloane.component';
import { RegistruValabilityComponent } from './registru-valability/registru-valability.component';
import { requireMinOneColleagueValidator } from 'src/app/validators/at-least-one-colleague';
import { UpdateGenerabilValabilityComponent } from './document-generabil/update-generabil-valability/update-generabil-valability.component';
import { Generic } from 'src/app/interfaces/generic.interface';
import { DocumentTemplateService } from 'src/app/platform/nomenclatoare/document-template/document-template.service';
import { AddSemnatariComponent } from './add-semnatari/add-semnatari.component';
import { DocumentTemplateSignaturesComponent } from 'src/app/platform/nomenclatoare/document-template/document-template-signatures/document-template-signatures.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { OperatorAccess, UserFunction } from 'src/app/platform/nomenclatoare/operatori/operatori.interface';
import { OperatoriService } from 'src/app/platform/nomenclatoare/operatori/operatori.service';
import { MotivRefuzDialogComponent } from './motiv-refuz-dialog/motiv-refuz-dialog.component';

@Component({
    selector: 'app-cereri-detalii',
    templateUrl: './cereri-detalii.component.html',
    styleUrls: ['./cereri-detalii.component.scss']
})
export class CereriDetaliiComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    private destroy$ = new Subject<void>();

    token!: string;
    isLoading = false;
    isActualizareCerereLoading = false;
    isDocumentOficialDisabled = false;
    selectedDocGenerabilToggle = 'active';
    selectedDocToggle = 'cereri';
    //selectedMessageToggle = 'cetatean';
    selectedMessagingToggle = 'internalMsg';
    selectedInfoExtra = 'info';
    selectedPFStatus = 'info';
    passedRequestId!: number;
    helper = helper;
    editorConfig!: AngularEditorConfig;
    safeHtml!: SafeHtml;
    documentTypesTranslation: any = {
        'toPrimarie': 1,
        'toCetatean': 2
    }
    documentTypesTranslationReverse: any = {
        1: 'toPrimarie',
        2: 'toCetatean'
    }

    showSignatures: any;
    cerere: ICerere | null = null;
    informatii_aditionale: any = this.cerere?.informatii;
    documenteCetatean!: DocumentCetatean[];
    documentCategories!: any[];

    sendMessageCetateanForm!: FormGroup;
    sendDocumentCetateanForm!: FormGroup;
    functiiForm!: FormGroup;
    sendMessageInternForm!: FormGroup;
    sendMessageNotitaForm!: FormGroup;
    notifyAnswer!: FormGroup;
    functiiOperator: any[] = [];
    uploadedFileNames: string[] = [];

    showValidateCard: boolean = true;

    user: any = null;
    userFunctions: UserFunction[] = [];
    activeFunction: UserFunction | null = null;
    userAccesses: OperatorAccess[] = [];
    activeAccess: OperatorAccess | null = null;

    directii: Generic[] = this.data.directii;

    // Reference to assignments component for refresh functionality
    @ViewChild(CerereFunctiiAssignmentComponent) assignmentsComponent!: CerereFunctiiAssignmentComponent;

    defaultChoiceParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    responseTimes = [
        { key: '3', value: 3 },
        { key: '5', value: 5 },
        { key: '7', value: 7 },
        { key: '10', value: 10 },
    ];

    uploading: any = {
        files_mesagerie_cetatean: false,
        files_mesagerie_intern: false,
        files_mesagerie_notita: false,
    };

    files: any = {
        files_mesagerie_cetatean: [],
        files_mesagerie_intern: [],
        files_mesagerie_notita: [],
    };
    hasDraft!: boolean;
    // Add coleagues functionality

    separatorKeysCodes: number[] = [ENTER, COMMA];
    filteredColeagues!: any;
    coleagues: Coleg[] = [];
    allColeagues: Coleg[] = [];
    coleaguesCtrl = new FormControl('');

    selectedSignature: number = -1
    destination_signatures_document: string = 'toPrimarie';
    useActiveFunction: boolean = false;
    selectedSpecificUser: any = null;
    showSpecificUserSelection: boolean = false;
    availableUsersForFunction: any[] = [];
    allowDelegation: boolean = false;
    canAllowDelegation: boolean = false;

    @ViewChild('coleagueInput') coleagueInput!: ElementRef<HTMLInputElement>;

    // Subscription to track our sabloane added from the button below messaging component
    private contentSubscription!: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<CereriDetaliiComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private authService: AuthService,
        private userService: UsersService,
        private fb: FormBuilder,
        private storageService: StorageService,
        private sanitizer: DomSanitizer,
        private appFileService: AppFilesService,
        private commonService: CommonService,
        public toastr: ToastrService,
        public permissionsService: PermissionsService,
        private componentService: DocumentTemplateService,
        private breakpointObserver: BreakpointObserver,
        private operatoriService: OperatoriService,
    ) {
        this.processToken();
        this.passedRequestId = this.data.cerere.id_cerere;

        console.log(this.data.directii);
    }

    onDestinatieChange(event: any, doc: any = null) {
        console.log(event, 'event?')
        if (doc !== null) {
            this.getSignatureList(doc)
        }
    }

    showEditSemnatari: boolean = false;
    selectSemnatariList: any = [];

    // editSemnatari(event: any, doc: any = null): void {
    //     this.showEditSemnatari = !this.showEditSemnatari;
    //     if (doc !== null && this.showEditSemnatari == true) {
    //         this.getSignatureList(doc)
    //     }
    // }

    editSemnatari(event: any, doc: any = null): void {
        this.showEditSemnatari = !this.showEditSemnatari;

        if (doc !== null && this.showEditSemnatari == true) {
            // Resetează valorile
            this.selectedSpecificUser = null;
            this.useActiveFunction = false;
            this.allowDelegation = false;
            this.showSpecificUserSelection = false;
            this.availableUsersForFunction = [];

            this.getSignatureList(doc);

            // Găsește signature-ul curent activ și setează valorile preselectate
            if (this.selectedSignature && this.selectedSignature !== -1) {
                this.findCurrentSignatureAndPreselect(doc);
            }
        }
    }

    findCurrentSignatureAndPreselect(doc: any) {
        const indexSignatureTypes: any = this.documentTypesTranslation[this.destination_signatures_document];
        const currentSignature = doc.signatures_doc[indexSignatureTypes]?.find((sig: any) =>
            sig.user_type === this.selectedSignature
        );

        console.log('current SIGNATURE: ', currentSignature);

        if (currentSignature) {
            // Setează checkbox-ul pentru funcția activă
            this.useActiveFunction = currentSignature.use_active_function || false;

            // Verifică dacă permite selecția specifică (bazat pe template sau alte criterii)
            this.checkIfSpecificUserAllowed(this.selectedSignature);

            // Încarcă utilizatorii pentru această funcție
            this.loadUsersForFunction(this.selectedSignature);

            // Dacă există un utilizator specific asignat, preselectează-l
            if (currentSignature.specific_user_id && currentSignature.specific_user_name) {
                // Așteaptă să se încarce utilizatorii, apoi preselectează
                setTimeout(() => {
                    const preselectedUser = this.availableUsersForFunction.find(user =>
                        user.id === currentSignature.specific_user_id
                    );
                    if (preselectedUser) {
                        this.selectedSpecificUser = preselectedUser;
                        console.log('PRESELECTEDUSER: ', preselectedUser)
                    }
                }, 1000);
            }

            console.log('Current signature found:', currentSignature);
            console.log('useActiveFunction set to:', this.useActiveFunction);
        }
    }

    // getSignatureList(doc: any = null) {
    //     if (doc !== null && this.showEditSemnatari == true) {
    //         this.selectedSignature = doc.validare_user_type
    //         console.log(doc)
    //         let extraOption = {
    //             user_type: 0,
    //             user_type_name: "Intocmitor"
    //         }
    //         this.selectSemnatariList.push(extraOption)
    //         let indexSignatureTypes: any = this.documentTypesTranslation[this.destination_signatures_document]
    //         // exactly our list - specified :)
    //         doc.signatures_doc[indexSignatureTypes].forEach((item: any) => {
    //             let obj = {
    //                 user_type: item.user_type,
    //                 user_type_name: item.user_type_name
    //             }
    //             this.selectSemnatariList.push(obj);
    //         })
    //     }
    // }

    getSignatureList(doc: any = null) {
        if (doc !== null && this.showEditSemnatari == true) {
            this.selectSemnatariList = []; // Resetează lista
            this.selectedSignature = doc.validare_user_type;

            console.log('doc.validare_user_type:', doc.validare_user_type);

            // let extraOption = {
            //     user_type: 0,
            //     user_type_name: "Intocmitor"
            // }
            // this.selectSemnatariList.push(extraOption);

            let indexSignatureTypes: any = this.documentTypesTranslation[this.destination_signatures_document];
            doc.signatures_doc[indexSignatureTypes].forEach((item: any) => {
                let obj = {
                    user_type: item.user_type,
                    user_type_name: item.user_type_name
                }
                this.selectSemnatariList.push(obj);
            });

            console.log('After getSignatureList - selectedSignature:', this.selectedSignature);
        }
    }

    editSemnatariSubmit(idDocGenerat: number) {
        // Swal.fire({
        // 	title: helper.dialogConfig.commonTitles.areYouSure,
        // 	text: 'O să modificati semnatarul curent. Continuați?',
        // 	icon: 'warning',
        // 	showCancelButton: true,
        // 	cancelButtonText: helper.dialogConfig.buttonLabels.close,
        // 	confirmButtonColor: helper.dialogConfig.colorButtons.standard,
        // 	confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
        // 	showLoaderOnConfirm: true,
        // 	reverseButtons: true,
        // 	allowOutsideClick: false,
        // }).then((result) => {
        // 	if (result.isConfirmed) {
        // 		this.isLoading = true;

        // 		this.getRequestInfo();
        // 		this.showEditSemnatari = false;
        // 	}
        // });

        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să modificați semnatarul curent. Continuați?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: () => {
                let data: any = {
                    destination_signatures_document: this.destination_signatures_document,
                    selectedSignature: this.selectedSignature,
                    useActiveFunction: this.useActiveFunction
                }

                // Add specific user assignment if selected
                if (this.selectedSpecificUser) {
                    data.specificUserId = this.selectedSpecificUser.id;
                    data.userFunctieId = this.selectedSpecificUser.user_functie_id;
                    data.specificAssignments = [{
                        user_type: this.selectedSignature,
                        user_id: this.selectedSpecificUser.id,
                        user_functie_id: this.selectedSpecificUser.user_functie_id,
                        user_name: this.selectedSpecificUser.name
                    }];
                }

                // Add delegation flag if allowed
                if (this.allowDelegation && this.canAllowDelegation) {
                    data.allowDelegation = true;
                }

                return this.cereriService
                    .updateCurrentSignatureDocument(idDocGenerat, data)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                    this.editSemnatari('hello');
                });
            }
        });
    }

    // onSignatureSelect() {
    //     // Load users with the selected function
    //     if (this.selectedSignature && this.selectedSignature !== -1) {
    //         this.loadUsersForFunction(this.selectedSignature);
    //         this.checkIfSpecificUserAllowed(this.selectedSignature);
    //     } else {
    //         this.availableUsersForFunction = [];
    //         this.showSpecificUserSelection = false;
    //     }
    // }

    onSignatureSelect() {
        console.log('onSignatureSelect called with:', this.selectedSignature);

        // Resetează valorile când se schimbă selecția
        this.selectedSpecificUser = null;
        this.useActiveFunction = false;
        this.allowDelegation = false;

        if (this.selectedSignature && this.selectedSignature !== -1) {
            this.checkIfSpecificUserAllowed(this.selectedSignature);
            this.loadUsersForFunction(this.selectedSignature);
        } else {
            this.availableUsersForFunction = [];
            this.showSpecificUserSelection = false;
        }

        console.log('After onSignatureSelect - showSpecificUserSelection:', this.showSpecificUserSelection);
    }

    loadUsersForFunction(functionId: number) {
        // Get users with this function from the operator service
        // Pass the only_active parameter to the backend
        this.operatoriService.getUsersByFunctie(functionId, this.useActiveFunction).subscribe({
            next: (response: any) => {
                if (response && response.data) {
                    // Handle both array and nested object responses
                    const userData = Array.isArray(response.data) ? response.data : (response.data.data || []);

                    if (Array.isArray(userData)) {
                        this.availableUsersForFunction = userData.map((user: any) => ({
                            id: user.id_user || user.id,
                            name: user.name || 'Unknown User',
                            email: user.email || '',
                            is_active: user.is_active_function || false,
                            user_functie_id: user.user_functie_id || user.id
                        }));

                        // No need to filter here since backend already filters if useActiveFunction is true
                        console.log(`Loaded ${this.availableUsersForFunction.length} users for function ${functionId} (active only: ${this.useActiveFunction})`);
                        console.log(this.availableUsersForFunction);
                    } else {
                        console.warn('Unexpected data format from getUsersByFunctie:', response);
                        this.availableUsersForFunction = [];
                    }
                } else {
                    this.availableUsersForFunction = [];
                }
            },
            error: (error) => {
                console.error('Error loading users for function:', error);
                this.availableUsersForFunction = [];
                // Show user-friendly error notification
                this.notificationService.warningSwal(
                    'Eroare',
                    'Nu s-au putut încărca utilizatorii pentru această funcție',
                    'error'
                );
            }
        });
    }

    onActiveFunctionToggle() {
        // Reload users when the active function checkbox is toggled
        if (this.selectedSignature && this.selectedSignature !== -1) {
            console.log('Active function toggle changed to:', this.useActiveFunction);
            this.loadUsersForFunction(this.selectedSignature);
        }
    }

    // checkIfSpecificUserAllowed(functionId: number) {
    //     // Check template configuration to see if specific user assignment is allowed
    //     // This would need to check against the document template signatures
    //     const cerereData = this.cerere as any;
    //     const currentDoc = cerereData?.documente_generate?.find((doc: any) => doc.showSignatures);
    //     if (currentDoc && currentDoc.template_signatures) {
    //         const templateSig = currentDoc.template_signatures.find((sig: any) =>
    //             sig.user_type === functionId &&
    //             sig.doc_type === this.documentTypesTranslation[this.destination_signatures_document]
    //         );

    //         if (templateSig) {
    //             this.showSpecificUserSelection = templateSig.allow_specific_user || false;
    //             this.canAllowDelegation = templateSig.allow_delegation || false;
    //         }
    //     } else {
    //         // Default to allowing specific user selection
    //         this.showSpecificUserSelection = true;
    //     }
    // }

    checkIfSpecificUserAllowed(functionId: number) {
        console.log('checkIfSpecificUserAllowed called with:', functionId);

        // Verifică configurația template-ului sau alte criterii pentru a determina
        // dacă se permite selecția persoanei specifice
        const cerereData = this.cerere as any;
        const currentDoc = cerereData?.generabile?.find((doc: any) => doc.id_document === this.showSignatures);

        if (currentDoc && currentDoc.signatures_doc) {
            const indexSignatureTypes: any = this.documentTypesTranslation[this.destination_signatures_document];
            const templateSig = currentDoc.signatures_doc[indexSignatureTypes]?.find((sig: any) =>
                sig.user_type === functionId
            );

            if (templateSig) {
                // Bazează decizia pe existența unui utilizator specific sau alte criterii
                this.showSpecificUserSelection = true; // Sau bazează pe templateSig.allow_specific_user
                this.canAllowDelegation = templateSig.allow_delegation || false;
            } else {
                this.showSpecificUserSelection = true; // Default la true pentru flexibilitate
                this.canAllowDelegation = false;
            }
        } else {
            // Default behavior
            this.showSpecificUserSelection = true;
            this.canAllowDelegation = false;
        }

        console.log('showSpecificUserSelection set to:', this.showSpecificUserSelection);
        console.log('canAllowDelegation:', this.canAllowDelegation);
    }



    processUserDetails() {
        var self = this;
        const userObj = self.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                self.user = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    ngOnInit(): void {
        const htmlFromBackend = `<span><span class='fa fa-clock-o'></span> 30z</span> <span class='green-text'><b>27z 21h </b></span>`;
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(htmlFromBackend);

        this.getRequestInfo();
        this.editorConfig = initializeEditor();
        this.getUsersActive();
        this.initializeCetateanForm();
        this.initNotifyAnswer();
        this.subscribeToContent();
        this.loadUserFunctions();
        this.loadUserAccess();

        this.sendDocumentCetateanForm = this.fb.group({
            files: this.fb.array([]),
        });

        this.componentService.getFunctiiUserList().subscribe({
            next: (data: any) => {
                return (this.functiiOperator = data.data);
            },
            error: (error) => {
                console.error('Error fetching data:', error);
            },
        });

        this.sendMessageInternForm = this.fb.group({
            message: new FormControl('', [Validators.required]),
            type: new FormControl('2'),
            coleagues: new FormControl(
                this.coleagues,
                requireMinOneColleagueValidator()
            ),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });
        this.sendMessageNotitaForm = this.fb.group({
            message: new FormControl('', [Validators.required]),
            type: new FormControl('3'),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });

        this.filteredColeagues = this.coleaguesCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value ? this._coleaguesFilter(value) : this.allColeagues.slice()
            )
        );
    }
    type!: string;
    onTypeChange(option: any) {
        this.type = option.value;
    }

    loadUserFunctions(): void {
        this.operatoriService.userFunctions$
            .pipe(takeUntil(this.destroy$))
            .subscribe(userFunctions => {
                this.userFunctions = userFunctions;
                this.activeFunction = this.userFunctions.find(func => func.is_active) || null;
            });
    }

    loadUserAccess(): void {
        this.operatoriService.userAccess$
            .pipe(takeUntil(this.destroy$))
            .subscribe(userAccesses => {
                this.userAccesses = userAccesses;
                this.activeAccess = this.userAccesses.find(access => access.active) || null;
            });
    }

    addSemnatari(doc: any) {
        console.log(doc.id_document);
        let isCerereDetalii = true;
        let data = {
            manual_override: true,
            // id_document: doc.id_document, // id_document generat
            id: doc.id_document, // template ID
            document_generabil_dual: doc.doc_type, // document_generabil_dual - doc_type - exemplar
            doc_type: this.documentTypesTranslation[this.destination_signatures_document], // document_generabil_dual - doc_type - exemplar
            name: doc.template // denumire template
        };
        const dialogRef = this.dialog.open(DocumentTemplateSignaturesComponent, {
            height: '70vh',
            maxHeight: '70vh',
            width: '75vh',
            maxWidth: '75vh',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }) => {
            if (success) {
                this.isLoading = true;
                this.rsyncSignaturesDocumentGenerat(doc.id_document);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.contentSubscription) {
            this.contentSubscription.unsubscribe();
        }
        this.destroy$.next();
        this.destroy$.complete();
    }

    initNotifyAnswer() {
        this.notifyAnswer = new FormGroup({
            notify_date_expire: new FormControl('', [Validators.required]),
        });
    }

    initializeCetateanForm() {
        this.sendMessageCetateanForm = this.fb.group({
            message: new FormControl('', [Validators.required]),
            type: new FormControl('1'),
            coleagues: new FormControl([]),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });
    }

    // This subscribes to any content change coming from Sabloane button below
    subscribeToContent() {
        this.contentSubscription = this.cereriService.sablonContent$.subscribe({
            next: (content) => {
                this.updateMessageFormControl(content);
            },
        });
    }
    // This updated our form control
    updateMessageFormControl(content: string) {
        // Update the 'message' form control with the new content
        this.sendMessageCetateanForm.controls['message'].setValue(content);
    }

    isAjutorCerere(): boolean {
        const slug = this.cerere?.slug || '';
        return slug === 'ajutor-carburant' || slug === 'ajutor-transport-public';
    }

    getDocumentTypeKeys(): string[] {
        return this.cerere ? Object.keys(this.cerere.documente) : [];
    }

    getDocumentKeys(docTypeKey: string): string[] {
        return this.cerere
            ? Object.keys(this.cerere.documente[docTypeKey].documente)
            : [];
    }

    prepareDocumentCategories(): void {
        if (this.cerere && this.cerere.documente) {
            this.documentCategories = Object.keys(this.cerere.documente).map(
                (key) => this.cerere?.documente[key]
            );
        }
    }

    handleButtonClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case 'validează':
                this.confirmValidareSolicitare();
                break;
            case 'invalidează':
                this.showValidateCard = false;
                this.confirmInValidareSolicitare();
                break;
            case 'anulare':
            case 'clasare':
                this.confirmAnulareSolicitare();
                break;
            case 'închidere lucrare':
                this.openInchidereSolicitare(this.cerere!);
                break;
            default:
                console.log('Unrecognized button value', buttonValue.toLowerCase());
        }
    }

    handleButtonResetClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case 'validează':
                this.resetValidareCerere();
                break;
            case 'invalidează':
                this.resetinValidareCerere();
                break;
            case 'anulare':
            case 'clasare':
                this.resetClasareCerere();
                break;
            case 'închidere lucrare':
                this.resetInchidereCerere();
                break;
            default:
                console.log('Unrecognized button value', buttonValue.toLowerCase());
        }
    }

    getRequestInfo() {
        this.isLoading = true;
        this.cereriService
            .getRequestById(this.passedRequestId)
            .pipe(map((response: any) => response.data))
            .subscribe(
                (requestData) => {
                    this.isLoading = false;
                    this.cerere = requestData;

                    this.hasDraft = requestData.hasDraft;
                    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(
                        (this.cerere as ICerere).sla
                    );
                    if (
                        typeof this.cerere?.generabile !== 'undefined' &&
                        this.cerere.generabile.length > 0
                    ) {
                        const foundNotSignedFinal = this.cerere.generabile.findIndex((item: any) => {
                            return (item.file_signed_final === null || (item.doc_type === 2 && item.file_signed_ex_cetatean === null))
                        });
                        const generabilIndex = foundNotSignedFinal ? foundNotSignedFinal : this.cerere.generabile.length - 1;
                        this.showSignatures = this.cerere.generabile[generabilIndex].id_document;
                    }

                    // Refresh assignments component to show latest changes from other users
                    if (this.assignmentsComponent) {
                        this.assignmentsComponent.refreshAssignments();
                    }
                },
                (error: any) => {
                    this.isLoading = false;
                    console.error('Error', error);
                    let msg;
                    try {
                        msg = error.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService
                        .warningSwal(this.errorTitle, msg, this.errorIcon)
                        .then((result) => {
                            this.closeDialog();
                        });
                }
            );
    }

    // Coleagues section

    private _coleaguesFilter(value: string | Coleg): Coleg[] {
        let filterValue = '';
        if (typeof value === 'string') {
            filterValue = value.toLowerCase();
        } else {
            filterValue = value.name.toLowerCase();
        }

        return this.allColeagues.filter((coleague) =>
            coleague.name.toLowerCase().includes(filterValue)
        );
    }

    addColeague(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        if (value) {
            const foundOption = this.allColeagues.find(
                (coleague) => coleague.name.toLowerCase() === value.toLowerCase()
            );
            if (foundOption) {
                this.coleagues.push(foundOption);
                this.sendMessageInternForm.controls['coleagues'].setValue([
                    ...this.coleagues,
                ]);
                this.sendMessageInternForm.controls[
                    'coleagues'
                ].updateValueAndValidity();
            }
        }

        event.chipInput!.clear();
        this.coleaguesCtrl.setValue(null);
    }

    removeColeague(coleague: Coleg): void {
        const index = this.coleagues.indexOf(coleague);

        if (index >= 0) {
            this.coleagues.splice(index, 1);
            // Update the form control to reflect changes and re-validate
            this.sendMessageInternForm.controls['coleagues'].setValue([
                ...this.coleagues,
            ]);
            this.sendMessageInternForm.controls['coleagues'].updateValueAndValidity();
        }
    }

    selectedColeagues(event: MatAutocompleteSelectedEvent): void {
        const selectedOption = this.allColeagues.find(
            (coleague) => coleague.name === event.option.viewValue
        );
        if (
            selectedOption &&
            !this.coleagues.find(
                (coleague) => coleague.id_user === selectedOption.id_user
            )
        ) {
            this.coleagues.push(selectedOption);
            this.coleagueInput.nativeElement.value = '';
            this.coleaguesCtrl.setValue(null);
            // Update the form control to reflect changes and re-validate
            this.sendMessageInternForm.controls['coleagues'].setValue([
                ...this.coleagues,
            ]);
            this.sendMessageInternForm.controls['coleagues'].updateValueAndValidity();
        }
    }

    getUsersActive() {
        this.userService
            .getUsersActive()
            .pipe(map((response: any) => response.data))
            .subscribe((requestData) => {
                this.allColeagues = requestData;
            });
    }

    onFileSelected(event: any, section: any) {
        const files = event.target.files;
        if (files) {
            var filesArray;
            switch (section) {
                case 'documentCetatean':
                    filesArray = this.sendDocumentCetateanForm.get('files') as FormArray;
                    break;

                case 'cetatean':
                    filesArray = this.sendMessageCetateanForm.get('files') as FormArray;
                    break;

                case 'intern':
                    filesArray = this.sendMessageInternForm.get('files') as FormArray;
                    break;

                case 'nota':
                    filesArray = this.sendMessageNotitaForm.get('files') as FormArray;
                    break;
            }

            Array.from(files).forEach((file: any) => {
                if (!this.uploadedFileNames.includes(file.name)) {
                    this.uploadedFileNames.push(file.name);
                    const fileControl = new FormControl(file);

                    filesArray.push(fileControl);
                }
            });
        }
    }

    deleteFile(fileName: string, section: any) {
        const nameIndex = this.uploadedFileNames.indexOf(fileName);
        if (nameIndex > -1) {
            this.uploadedFileNames.splice(nameIndex, 1);
        }
        var filesArray: any;
        switch (section) {
            case 'cetatean':
                filesArray = this.sendMessageCetateanForm.get('files') as FormArray;
                break;

            case 'intern':
                filesArray = this.sendMessageInternForm.get('files') as FormArray;
                break;

            case 'nota':
                filesArray = this.sendMessageNotitaForm.get('files') as FormArray;
                break;
        }

        // const filesArray = this.sendMessageForm.get('files') as FormArray;
        const fileIndex = filesArray.controls.findIndex(
            (control: any) => control.value.name === fileName
        );
        if (fileIndex > -1) {
            filesArray.removeAt(fileIndex);
        }
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token: string) => {
            this.token = token;
            this.cereriService.setToken(token);
            this.processUserDetails();
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    onDocGenerabilChange(event: MatButtonToggleChange) {
        this.selectedDocGenerabilToggle = event.value;
    }

    onDocChange(event: MatButtonToggleChange) {
        this.selectedDocToggle = event.value;
    }

    // onMessageChange(event: MatButtonToggleChange) {
    //     this.selectedMessageToggle = event.value;
    // }

    onMessagingChange(event: MatButtonToggleChange) {
        this.selectedMessagingToggle = event.value;
    }

    resetAllForms() {
        if (this.sendMessageInternForm.value) {
            this.coleagues = [];
            this.sendMessageInternForm.get('message')?.setValue(null);
            this.sendMessageInternForm.get('type')?.setValue('2');
            this.sendMessageInternForm.get('notify')?.setValue(false);

            const filesFormArray = this.sendMessageInternForm.get(
                'files'
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageInternForm.clearValidators();
        }

        if (this.sendMessageCetateanForm.value) {
            this.sendMessageCetateanForm.get('message')?.setValue('');
            this.sendMessageCetateanForm.get('type')?.setValue('1');
            this.sendMessageCetateanForm.get('notify')?.setValue(false);
            this.notifyAnswer.get('notify_date_expire')?.setValue(null);

            const filesFormArray = this.sendMessageCetateanForm.get(
                'files'
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageCetateanForm.clearValidators();
        }

        if (this.sendMessageNotitaForm.value) {
            this.sendMessageNotitaForm.get('message')?.setValue('');
            this.sendMessageNotitaForm.get('type')?.setValue('3');
            this.sendMessageNotitaForm.get('notify')?.setValue(false);

            const filesFormArray = this.sendMessageNotitaForm.get(
                'files'
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageNotitaForm.clearValidators();
        }
    }

    submitMessage(section: any) {
        this.isLoading = true;

        var newMessage;
        switch (section) {
            case 'cetatean':
                newMessage = this.sendMessageCetateanForm
                    .value as RequestMessageToCetateanPayload;

                if (this.sendMessageCetateanForm.get('notify')?.value === true) {
                    newMessage = Object.assign(newMessage, {
                        notify_date_expire: this.notifyAnswer.value.notify_date_expire,
                    });
                }
                break;
            case 'intern':
                newMessage = this.sendMessageInternForm
                    .value as RequestMessageInternPayload;
                break;

            case 'nota':
                newMessage = this.sendMessageNotitaForm
                    .value as RequestMessageNotitaPayload;
                break;
        }

        this.cereriService
            .postMessage(this.cerere!.id_cerere, newMessage)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                    this.uploadedFileNames = [];
                    this.resetAllForms();
                })
            )
            .subscribe({
                next: (res) => {
                    this.isLoading = true;
                    // Commented the function below so that we dont have a popup when the loading spinner is active

                    // this.notificationService.warningSwal(
                    //   this.successTitle,
                    //   'Cerere actualizata cu succes!',
                    //   this.successIcon
                    // );
                    // refresh data please
                    this.getRequestInfo();

                    switch (section) {
                        case 'cetatean':
                            this.sendMessageCetateanForm.patchValue({
                                message: '',
                                files: [],
                            });
                            this.notifyAnswer.patchValue({
                                notify: false,
                                notify_date_expire: null,
                            });
                            break;

                        case 'intern':
                            this.sendMessageInternForm.patchValue({
                                message: '',
                                files: [],
                                coleagues: this.coleagues,
                            });
                            break;

                        case 'nota':
                            this.sendMessageNotitaForm.patchValue({
                                message: '',
                                files: [],
                            });
                            break;
                    }

                    // this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    confirmPreluarePersonala() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să preluați solicitarea curentă. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .preluarePersonala(this.cerere!.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Cerere preluată cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    confirmInValidareSolicitare(): void {
        this.openMotivRefuzDialog('invalidare', () => this.getRequestInfo());
    }

    confirmAnulareSolicitare(): void {
        this.openMotivRefuzDialog('clasare', () => this.getRequestInfo());
    }

    confirmValidareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.validate,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .validateCerere(this.cerere!.id_cerere)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    openInchidereSolicitare(data: ICerere) {
        let dialogRef = this.dialog.open(ModalInchidereLucrareComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    downloadDocument(file: any) {
        let fullPath = this.cereriService.downloadDocumentUrl + file.id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentTableSignatures(id: number) {
        let fullPath = this.cereriService.downloadTableSignaturesURL + id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentGeneratBE(id: number, doc_type: number) {
        // + '/' + doc_type;
        let fullPath =
            this.cereriService.downloadDocumentGeneratUrl + id + '/' + doc_type;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentOfficial(id: number, doc_type: number = 1) {
        // let fullPath = this.cereriService.downloadDocumentSignedUrl + id; // wrong ?

        let fullPath = this.cereriService.downloadDocumentOfficialUrl + id + '?doc_type=' + doc_type;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentSigned(id: number, doc_type: number = 1) {
        let fullPath = this.cereriService.downloadDocumentSignedUrl + id + '?doc_type=' + doc_type;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentFromSignatureSigned(id: number) {
        let fullPath = this.cereriService.downloadDocumentSignatureSignedUrl + id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadAnexa(file: any) {
        let fullPath = this.cereriService.downloadDocumentAnexaUrl + file.id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    addFileCetatean(event: any, key: 'file') {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.sendMessageCetateanForm.get('files')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileData) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading[key] = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.sendMessageCetateanForm.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;
                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    addFileIntern(event: any, key: 'file') {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.sendMessageInternForm.get('files')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileData) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading[key] = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.sendMessageInternForm.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;

                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    addFileNotita(event: any, key: 'file') {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.sendMessageNotitaForm.get('files')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileData) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading[key] = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            // const currentFiles = this.sendMessageNotitaForm.get('files')?.value || [];
                            // currentFiles.push(result.data);
                            // this.sendMessageNotitaForm.get('files')?.setValue(currentFiles);
                            const files = this.sendMessageNotitaForm.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;

                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    removeFileCetatean(index: number) {
        // const currentFiles = this.sendMessageCetateanForm.value.files || [];
        // const currentFiles = this.sendMessageCetateanForm.get('files')?.value || [];
        // currentFiles.splice(index, 1);
        // this.sendMessageCetateanForm.patchValue({ files: currentFiles });

        const files = this.sendMessageCetateanForm.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    removeFileIntern(index: number) {
        // const currentFiles = this.sendMessageInternForm.get('files')?.value || [];
        // currentFiles.splice(index, 1);
        // this.sendMessageInternForm.patchValue({ files: currentFiles });

        const files = this.sendMessageInternForm.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    removeFileNota(index: number) {
        // const currentFiles = this.sendMessageNotitaForm.get('files')?.value || [];
        // currentFiles.splice(index, 1);
        // this.sendMessageNotitaForm.patchValue({ files: currentFiles });

        const files = this.sendMessageNotitaForm.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    generateDocOfficial() {
        const is_address = false;

        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: {
                cerere: this.cerere,
                type: 1, // doc official
                is_address: is_address,
            }
        };

        const dialogRef = this.dialog.open(DocumentGenerabilComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    generateDocAdresa() {
        const is_address = true;

        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: {
                cerere: this.cerere,
                type: 2, // adrese
                is_address: is_address,
            }
        };

        const dialogRef = this.dialog.open(DocumentGenerabilComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    updateDocumentGenerat(row: DocumentGenerabil) {
        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: row
        };

        const dialogRef = this.dialog.open(EditDocumentOficialComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    // ==================== Document Assignment Methods ==================== //

    /**
     * Open document assignment dialog
     */
    openDocumentAssignment(document: DocumentGenerabil): void {
        const dialogRef = this.dialog.open(DocumentAssignmentComponent, {
            width: '700px',
            maxWidth: '90vw',
            disableClose: true,
            data: {
                document: document,
                cerereId: this.cerere!.id_cerere,
                directii: this.directii
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.success) {
                // Refresh the cerere data to show updated assignments
                this.getRequestInfo();

                if (result.unassigned) {
                    this.notificationService.successSwal(
                        'Succes',
                        'Asignarea documentului a fost eliminată cu succes'
                    );
                } else {
                    this.notificationService.successSwal(
                        'Succes',
                        'Documentul a fost asignat cu succes'
                    );
                }
            }
        });
    }

    /**
     * Auto-assign all documents for the current cerere
     */
    autoAssignAllDocuments(): void {
        this.notificationService.confirmSwal(
            'Confirmare',
            'Doriți să asignați automat toate documentele neasignate folosind asignările existente ale cererii?',
        ).then((result: any) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService.autoAssignAllDocumentsForCerere(this.cerere!.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (response) => {
                            this.getRequestInfo();
                            const results = response.data || [];
                            const successCount = results.filter((r: any) => r.success).length;
                            const totalCount = results.length;

                            if (successCount > 0) {
                                this.notificationService.successSwal(
                                    'Succes',
                                    `${successCount} din ${totalCount} documente au fost asignate automat`
                                );
                            } else {
                                this.notificationService.warningSwal(
                                    'Atenție',
                                    'Nu au fost găsite documente care să poată fi asignate automat',
                                    'warning'
                                );
                            }
                        },
                        error: (error) => {
                            console.error('Error auto-assigning documents:', error);
                            this.notificationService.warningSwal(
                                'Eroare',
                                'A apărut o eroare la asignarea automată a documentelor',
                                'error'
                            );
                        }
                    });
            }
        });
    }

    /**
     * Get assignment status display for a document
     */
    getDocumentAssignmentStatus(document: DocumentGenerabil): string {
        if (!document.has_assignment) {
            return 'Neasignat';
        }

        if (document.assigned_user_name) {
            return `Asignat: ${document.assigned_user_name}`;
        }

        if (document.assigned_functie_name) {
            return `Funcție: ${document.assigned_functie_name}`;
        }

        return 'Asignare parțială';
    }

    /**
     * Get assignment CSS class for a document
     */
    getDocumentAssignmentCssClass(document: DocumentGenerabil): string {
        if (!document.has_assignment) {
            return 'badge-light';
        }

        if (document.assigned_user_name) {
            return 'badge-success';
        }

        if (document.assigned_functie_name) {
            return 'badge-warning';
        }

        return 'badge-secondary';
    }

    downloadDocumentGenerat(row: DocumentGenerabil, doc_type: number) {
        if (row.file_signed_final !== null) {
            this.downloadDocumentOfficial(row.id_document, doc_type);
        } else if (row.file_signed !== null) {
            this.downloadDocumentSigned(row.id_document, doc_type);
        } else {
            this.downloadDocumentGeneratBE(row.id_document, doc_type);
        }
    }

    validateDocument(documentGeneratId: number, type: number, doc_type: number = 0) {
        const dialogRef = this.dialog.open(CerereValidareComponent, {
            minHeight: 'auto',
            maxHeight: 'auto',
            minWidth: '50vw',
            maxWidth: '50vw',
            disableClose: true,
            data: {
                id: documentGeneratId,
                type,
                doc_type
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    viewIstoricDocument(row: ICerere) {
        const dialogRef = this.dialog.open(IstoricDocumentGenerabilComponent, {
            minHeight: '50vh',
            maxHeight: '50vh',
            minWidth: '60vw',
            maxWidth: '60vw',
            disableClose: true,
            data: row.istoric,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    destroyDocumentGenerat(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.deleteDocument,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .destroyDocument(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                this.isDocumentOficialDisabled = false;
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    switchViewSignatures(doc: any) {
        this.showSignatures = doc.id_document;
        this.showEditSemnatari = false;

        // get document info
        this.destination_signatures_document = this.documentTypesTranslationReverse[doc.doc_type_active]
    }

    downloadSignedDocument(documentId: number, userType: number) {
    }

    resetDocument(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.headers.error,
            text: this.helper.swalTextConfig.generalMessages.confirmReset,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            reverseButtons: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .resetDocumentValidated(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetDocumentIntocmitor(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.headers.error,
            text: this.helper.swalTextConfig.generalMessages.confirmReset,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .resetDocumentIntocmitorValidated(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    // this.isDocumentOficialDisabled = true; // i don't understand this rule.. i need explination please :)
                    this.getRequestInfo();
                });
            }
        });
    }

    anulareCerereSuperior(signatureId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.deleteDocumentCancel,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .anulareSuperiorDocument(signatureId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentCancelSuccess,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    isObjectEmpty(obj: any): boolean {
        return obj && Object.keys(obj).length === 0;
    }

    onCerereChanged(data: ICerere) {
        this.cerere = data;
    }

    onInfoExtraChange(event: MatButtonToggleChange) {
        this.selectedInfoExtra = event.value;
    }

    onPFInfoChange(event: MatButtonToggleChange) {
        this.selectedPFStatus = event.value;
    }

    // This function checks if all signatures are not null inside a signature array of objects for a any doc generabil
    allFilesSigned(signatures: any): boolean {
        return signatures.every((signature: any) => signature.file_signed !== null);
    }
    // mesaj catre cetatean nu mai apare ceasul - de vazut de ce

    // aici face sabina, daca intarzie raspunsul trebuie sa-mi trimita ceva
    // daca l-a vazut, tb sa imi trimita ceva, un seen si sa modificam statusul cererii

    openRegistruValability(data: any) {
        const dialogRef = this.dialog.open(RegistruValabilityComponent, {
            minWidth: '40vw',
            maxWidth: '40vw',
            data: {
                id_document: data.id_document,
                passedRequestId: this.passedRequestId,
                valability: data.valability,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    showPreluareNumarRegistratura() {
        return (
            this.cerere?.id_user_assigned !== null &&
            this.cerere?.id_user_assigned == this.user.id_user &&
            this.cerere?.indoc_number == null &&
            this.permissionsService.hasPermission(
                'dgaspc-module.cerere.generare_numar_solicitare_cerere'
            )
        );
    }

    confirmPreluareNumarRegistratura() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Veți prelua un număr de registratură pentru solicitarea curentă. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .preluareNumarRegistratura(this.cerere!.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Număr de registratură preluat cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    openSabloane() {
        const dialogRef = this.dialog.open(CerereDetaliiSabloaneComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '50vw',
            maxWidth: '50vw',
            disableClose: true,
        });

        dialogRef
            .afterClosed()
            .subscribe(({ success }: { success: boolean }) => { });
    }

    sendDocumentToIntocmitor(signatureId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să trimiteți documentul înapoi pe flux la Întocmitor',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Completați motivul...',
            reverseButtons: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .sendDocumentToIntocmitor(signatureId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Operațiune rulată cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    sendDocumentForwardIntocmitor(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O sa trimiteți documentul mai departe pe flux confirmând documentul încărcat ca fiind cel corect',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Completați motivul...',
            reverseButtons: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .sendDocumentForwardIntocmitor(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Operațiune rulată cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    sendDocumentForwardToSigner(signatureId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să trimiteți documentul mai departe pe flux confirmând documentul încărcat ca fiind cel corect',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Completați motivul...',
            reverseButtons: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .sendDocumentForwardToSigner(signatureId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Operațiune rulată cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    rsyncSignaturesDocumentGenerat(documentId: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să resetați semnatarii. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .rsyncSignaturesDocumentGenerat(documentId)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Semnatari resetați cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    generareDraftBtn() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Doriți să generați documentul?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .generareDraft(this.cerere!.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))

                    .subscribe({
                        next: (res: Blob) => {
                            this.isLoading = true;
                            const blobUrl = URL.createObjectURL(res);
                            window.open(blobUrl, '_blank');
                            this.notificationService.warningSwal(
                                this.successTitle,
                                'Document generat cu succes!',
                                this.successIcon
                            );
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    // special operations, we need to reset states of special activities on cerere
    resetValidareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea validării de cerere?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesita completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetValidareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetinValidareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea invalidării de cerere?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesita completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message');
                    // return 'Este necesar completarea unui motiv!';

                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetinValidareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetClasareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea clasării de cerere?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesita completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message');
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetClasareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetInchidereCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea închiderii de cerere? Confirmați anularea de închidere a cererii în cadrul modulului de INDOC - Registratură?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message');
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetInchidereCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    notificareCetateanDocumentOficial(documentId: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Doriți să trimiteți/notificați cetățeanul privind documentul/documentele oficiale încărcate?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message');
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .sendNotificationCetateanDocumentOficial(documentId)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Notificare trimisă cu succes!',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    editDateDocGenerabil(id_document: number) {
        const dialogRef = this.dialog.open(UpdateGenerabilValabilityComponent, {
            minWidth: '40vw',
            maxWidth: '40vw',
            data: id_document,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    resetUploadDocumentOfficial(id_document: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să resetați documentul. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .resetUploadDocumentOfficial(id_document)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Document resetat cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    resetDocumentOficialNotificareCetatean(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să resetați documentul. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .resetDocumentOficialNotificareCetatean(id)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Document resetat cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    removeSemnatari() {
        Swal.fire({
            title: helper.dialogConfig.headers.error,
            text: 'Prin apăsarea butonului de confirmare veți șterge semnatarul selectat!',
            icon: 'success',
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.getRequestInfo();
            }
        });
    }

    // actualizare document generat - setare tip document
    setDocTypeForDocument(idDocGenerat: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "O sa actualizati tipul documentului Generat/In lucru",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return this.cereriService
                    .setDocTypeForDocument(idDocGenerat)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    allowMessages() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să modificați dacă cetățeanul poate transmite mesaje.',
            showCancelButton: true,
            confirmButtonText: this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result: any) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService.allowMessages(this.passedRequestId)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: () => {
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Modificat cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        }
                    })
            }
        })
    }

    onIsLoadingChange(event: boolean) {
        this.isLoading = event;
    }

    onAssignmentsUpdated(assignmentSummary: AssignmentSummary) {
        // Handle assignment updates if needed
        // This could trigger UI updates or notifications
        console.log('Assignments updated:', assignmentSummary);
    }

    private openMotivRefuzDialog(
        type: import('./motiv-refuz-dialog/motiv-refuz-dialog.component').MotivRefuzDialogType,
        onSuccess: () => void
    ): void {
        const dialogRef = this.dialog.open(MotivRefuzDialogComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                type,
                id_cerere: this.cerere!.id_cerere,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                onSuccess();
            }
        });
    }
}
